import { render, staticRenderFns } from "./Cooperation.vue?vue&type=template&id=e8582db0&scoped=true&"
import script from "./Cooperation.vue?vue&type=script&lang=js&"
export * from "./Cooperation.vue?vue&type=script&lang=js&"
import style0 from "./Cooperation.vue?vue&type=style&index=0&id=e8582db0&scoped=true&lang=css&"
import style1 from "./Cooperation.vue?vue&type=style&index=1&id=e8582db0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8582db0",
  null
  
)

export default component.exports